import React from "react";
import { Link } from "react-router-dom";
import headerImage1 from "../../assets/images/header/1.png";
import headerImage2 from "../../assets/images/header/2.png";

const PageHeader = ({ title = "Page Title", breadcrumbs = [] }) => {
  return (
    <div>
      <section
        className="page-header bg--cover"
        style={{
          backgroundImage: `url(${headerImage1})`,
        }}
      >
        <div className="container">
          <div className="page-header__content">
            <h2 style={{ textAlign: "left" }}>{title}</h2>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0">
                {breadcrumbs.map((item, index) => (
                  <li
                    key={index}
                    className={`breadcrumb-item ${
                      index === breadcrumbs.length - 1 ? "active" : ""
                    }`}
                    aria-current={index === breadcrumbs.length - 1 ? "page" : undefined}
                  >
                    {item.link ? <Link to={item.link}>{item.label}</Link> : item.label}
                  </li>
                ))}
              </ol>
            </nav>
          </div>
          <div className="page-header__shape">
            <span className="page-header__shape-item page-header__shape-item--1">
              <img src={headerImage2} alt="shape-icon" />
            </span>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PageHeader;
